import Section from "../Section"
import styles from "./Wysiwyg.module.scss"

const WysiwygBlock = ({ data }) => {
  const {
    section_teaser,
    section_headline,
    section_subline,
    section_text,
    section_links,
    wysiwyg_content: content,
  } = data

  return (
    <Section
      teaser={section_teaser}
      headline={section_headline}
      subline={section_subline}
      text={section_text}
      links={section_links}
    >
      <div className="container">
        {content && (
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </Section>
  )
}

export default WysiwygBlock
